import React from 'react';
import {
  Box,
  Button,
  ColumnLayout,
  Container,
  CopyToClipboard,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { BulletList } from './checkDisplay';
import { buildReviewerReport, reviewerReportFilename } from './reviewerReport';
import { downloadText } from './download';
import { CommentContext } from './CommentContext';

/**
 * ISFR's Reviewer Breakdown tab, next after the Approval Summary: the reasons and
 * actions, then the context the reviewer copies into their own AI tool to draft
 * the internal comment and the partner comment. The download holds every check in
 * full as one readable file.
 */

export const REVIEWER_TAB_ID = 'isfr-reviewer-breakdown';

const listOrNote = (read, emptyText, unreadableText) => {
  if (read.status === 'unreadable') return <Box color="text-body-secondary">{unreadableText}</Box>;
  if (read.status !== 'ok' || read.value.length === 0) {
    return <Box color="text-body-secondary">{emptyText}</Box>;
  }
  return <BulletList items={read.value} />;
};

export const ReviewerBreakdown = ({ request, view, onOpenTab }) => (
  <SpaceBetween size="l">
    <Container
      header={(
        <Header
          variant="h2"
          description="The full reviewer view, including detail the partner does not see."
          actions={(
            <SpaceBetween direction="horizontal" size="xs">
              {view.checks.reviewerComment && (
                <CopyToClipboard
                  variant="button"
                  copyButtonText="Copy reviewer note"
                  copySuccessText="Reviewer note copied"
                  copyErrorText="Reviewer note failed to copy"
                  textToCopy={view.checks.reviewerComment}
                />
              )}
              <Button
                iconName="download"
                onClick={() => downloadText(reviewerReportFilename(request), buildReviewerReport(request), 'text/markdown')}
              >
                Download full details
              </Button>
            </SpaceBetween>
          )}
        >
          Reasons and actions
        </Header>
      )}
    >
      <ColumnLayout columns={2} variant="text-grid">
        <div data-testid="isfr-reviewer-reasons">
          <Box variant="awsui-key-label">Reasons</Box>
          {listOrNote(view.reviewerReasons, 'No reasons recorded.', 'The reasons on this record could not be read.')}
        </div>
        <div data-testid="isfr-reviewer-actions">
          <Box variant="awsui-key-label">Actions</Box>
          {listOrNote(view.reviewerActions, 'No actions recorded.', 'The actions on this record could not be read.')}
        </div>
      </ColumnLayout>
    </Container>
    <CommentContext request={request} view={view} onOpenTab={onOpenTab} />
  </SpaceBetween>
);
